import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";
import GalleryPage from "./pages/gallery";
import HomePage from "./pages/home/homepage";
import AboutPage from "./pages/routes/about_page";
import ProjectsPage from "./pages/routes/projects_page";
import SkillsPage from "./pages/routes/skills_page";
import AiPage from "./pages/routes/ai_page";
import CodingToolsPage from "./pages/routes/coding_tools_page";
import GamesPage from "./pages/routes/games_page";
import ExperiencePage from "./pages/routes/experience_page";
import ContactPage from "./pages/routes/contact_page";
import MujiburPage from "./pages/routes/mujibur_page";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "./theme/themeContext";
import AiChatbox from "./pages/common/ai_chatbox";

const root = ReactDOM.createRoot(document.getElementById("root"));

function ChessPage() {
  return (
    <iframe
      className="standalone-html-frame"
      src="/html/chess.html"
      title="Chess"
    />
  );
}

function RoutedAppShell() {
  const location = useLocation();
  const isChessPage = location.pathname.replace(/\/+$/, "") === "/hakkim/chess";
  const isMujiburPage = location.pathname.replace(/\/+$/, "") === "/project/mujibur";

  return (
    <>
      <Routes>
        <Route index element={<HomePage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="skills" element={<SkillsPage />} />
        <Route path="known-ais" element={<AiPage />} />
        <Route path="coding-tools" element={<CodingToolsPage />} />
        <Route path="games" element={<GamesPage />} />
        <Route path="experience" element={<ExperiencePage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="project/mujibur" element={<MujiburPage />} />
        <Route path="gallery" element={<GalleryPage />} />
        <Route path="hakkim/chess" element={<ChessPage />} />
      </Routes>
      {!isChessPage && !isMujiburPage && (
        <>
          <div className="copy-rights py-3 text-center">
            <small>
              <i>Copyright &copy; 2026 abdrahman.in. All rights reserved</i>
            </small>
          </div>
          <AiChatbox />
        </>
      )}
    </>
  );
}

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <div className="app-shell">
        <BrowserRouter>
          <RoutedAppShell />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
